/** Accept relative API links as well as links expanded by the push template. */
export function notificationPath(link: unknown): string | undefined {
  if (typeof link !== 'string') return undefined;
  if (link.startsWith('/') && !link.startsWith('//')) return link;
  if (/^https?:\/\//i.test(link)) {
    try {
      const url = new URL(link);
      return `${url.pathname}${url.search}${url.hash}`;
    } catch {
      return undefined;
    }
  }
  const scheme = link.indexOf('://');
  return scheme > 0 ? `/${link.slice(scheme + 3).replace(/^\/+/, '')}` : undefined;
}
